import React from 'react';

const DoctorInfoCard = ({ doctorInfo, specialty }) => {
  return (
    <div className="doctor-card card_background">
      <div className="doctor-header ">
        <div className="doctor-image-placeholder">
          <i className="fas fa-user-md"></i>
        </div>
        <div style={{ width: "100%", display: "grid", placeItems: "center" }}>
          <h3 className="doctor-name"> Dr. {doctorInfo.get_full_name}</h3>
          <p className="doctor-specialty">{specialty.nombre}</p>
        </div>
      </div>
      {/*
      <div className="doctor-stats">
        <div className="stat-item">
          <span className="stat-value">{doctorInfo.rating}</span>
          <span className="stat-label">Calificación</span>
        </div>
        <div className="stat-item">
          <span className="stat-value">{doctorInfo.experience}</span>
          <span className="stat-label">Años exp.</span>
        </div>
        <div className="stat-item">
          <span className="stat-value">{doctorInfo.recommended}%</span>
          <span className="stat-label">Recomendado</span>
        </div>
      </div>*/}
    </div>
  );
};

export default DoctorInfoCard;